"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLegoNavigator = exports.LegoToaster = exports.LegoNavigator = exports.useTheming = exports.useTheme = exports.LegoProvider = exports.LegoContext = exports.DefaultThemingContext = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("./hooks");

/*
 *  toolkit/providers.tsx
 *  Project-Lego
 *
 * This files defines providers used to supply settings and configurations
 * to Lego
 *
 *  Created by Lucas Liepert on 06/25/2020
 *  Copyright © 2020-present ContextLogic Inc. All rights reserved.
 */

/* eslint-disable filenames/match-exported */
var Proxima = {
  Regular: "Proxima-Regular",
  Medium: "Proxima-Medium",
  Semibold: "Proxima-Semibold",
  Bold: "Proxima-Bold"
};
var LegoCSS = "\n@font-face {\n  font-family: ".concat(Proxima.Regular, ";\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-regular\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Regular, ";\n  font-style: italic;\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-regularit\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Medium, ";\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-medium\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Medium, ";\n  font-style: italic;\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-mediumit\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Semibold, ";\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-semibold\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Semibold, ";\n  font-style: italic;\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-semiboldit\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Bold, ";\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-bold\")\n    format(\"opentype\");\n}\n@font-face {\n  font-family: ").concat(Proxima.Bold, ";\n  font-style: italic;\n  src: url(\"//d2ujdsqe3ri19m.cloudfront.net/latest/assets/fonts/proximanova-boldit\")\n    format(\"opentype\");\n}\n");
var defaultFontContext = {
  regular: Proxima.Regular,
  bold: Proxima.Bold,
  medium: Proxima.Medium,
  semibold: Proxima.Semibold
}; // TODO [lliepert]: update with new palette from ThemeStore

var DefaultThemingContext = {
  theme: {
    // text colors
    textWhite: "#FFFFFF",
    textUltraLighter: "#D5DFE6",
    textUltralight: "#C4CDD5",
    textLight: "#5A7385",
    textDark: "#4A5F6E",
    textBlack: "#152934",
    textPlaceholder: "#C4CDD5",
    // surface colors
    surfaceLightest: "#FFFFFF",
    surfaceLighter: "#F8FAFB",
    surfaceLight: "#EEF2F5",
    surface: "#D5DFE6",
    surfaceDark: "#C4CDD5",
    surfaceDarker: "#898F95",
    // hover colors
    hoverColor: "#5b5b5b",
    hoverBackground: "#f2f6f9",
    // specific background colors
    inputBackground: "#FFFFFF",
    pageBackground: "#F8FAFB",
    modalBackground: "#4a5f6e",
    info: "#C4CDD5",
    // border gray
    borderPrimaryLightest: "#FFFFFF",
    borderPrimaryLighter: "#F8FAFB",
    borderPrimaryLight: "#EEF2F5",
    borderPrimary: "#D5DFE6",
    borderPrimaryDark: "#C4CDD5",
    borderPrimaryDarker: "#898F95",
    // core color / wish blue
    corePrimaryLightest: "#E6F7FF",
    corePrimaryLighter: "#cef2fd",
    corePrimaryLight: "#79D6FA",
    corePrimary: "#2FB7EC",
    corePrimaryDark: "#006BA0",
    corePrimaryDarker: "#1A4379",
    corePrimaryDarkest: "#001D53",
    // cyan
    positiveLighter: "#92F1D3",
    positiveLight: "#2EE3AA",
    positive: "#1ACC94",
    positiveDark: "#318562",
    positiveDarker: "#2A7265",
    positiveDarkest: "#1E6458",
    // yellow
    warningLighter: "#FFF0BB",
    warningLight: "#FFE380",
    warning: "#FFD560",
    warningDark: "#FFC72C",
    warningDarker: "#F0B616",
    warningDarkest: "#E4AB0F",
    // red
    negativeLighter: "#FADDE2",
    negativeLight: "#F1ABB5",
    negative: "#EC8998",
    negativeDark: "#E56175",
    negativeDarker: "#DB2441",
    negativeDarkest: "#CA213C",
    // cash green
    cashLighter: "#C2EF8A",
    cashLight: "#A5E15D",
    cash: "#88C43F",
    cashDark: "#4A8305",
    cashDarker: "#3f7004",
    cashDarkest: "#355F03",
    // blue
    primaryLight: "#D0DBFF",
    primary: "#305BEF",
    primaryDark: "#1A4379",
    // palace blue
    secondaryLighter: "#E7EEFD",
    secondaryLight: "#C3D4FA",
    secondary: "#8CACF6",
    secondaryDark: "#376EEE",
    secondaryDarker: "#2561EC",
    secondaryDarkest: "#0E3AA1",
    // purple
    tertiaryLighter: "#E8E0FF",
    tertiaryLight: "#CBB9FF",
    tertiary: "#AE92FF",
    tertiaryDark: "#8055FF",
    tertiaryDarker: "#7443FF",
    tertiaryDarkest: "#6719FF",
    // orange
    quaternaryLigher: "#F9D3AE",
    quaternaryLight: "#FABF86",
    quaternary: "#F7A14D",
    quaternaryDark: "#EF8D2E",
    quaternaryDarker: "#DE7712",
    quaternaryDarkest: "#AF5E0E"
  },
  fonts: defaultFontContext
};
exports.DefaultThemingContext = DefaultThemingContext;
var defaultContext = {
  theming: DefaultThemingContext,
  env: "production",
  locale: "en"
}; // exported solely for legacy class-based components

var LegoContext = /*#__PURE__*/_react["default"].createContext(defaultContext);

exports.LegoContext = LegoContext;

var LegoProvider = function LegoProvider(_ref) {
  var _ref$env = _ref.env,
      env = _ref$env === void 0 ? "production" : _ref$env,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? DefaultThemingContext : _ref$theming,
      toasts = _ref.toasts,
      children = _ref.children,
      navigation = _ref.navigation,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? "en" : _ref$locale;
  var activeTheming = {
    theme: theming.theme || DefaultThemingContext.theme,
    fonts: theming.fonts || DefaultThemingContext.fonts
  };
  var context = {
    env: env,
    theming: activeTheming,
    locale: locale,
    toasts: toasts,
    navigation: navigation
  };
  (0, _hooks.useMountEffect)(function () {
    if (!window) {
      return;
    }

    var htmlDiv = document.createElement("div");
    htmlDiv.innerHTML = "<style>" + LegoCSS + "</style>";

    var _document$getElements = document.getElementsByTagName("head"),
        _document$getElements2 = (0, _slicedToArray2["default"])(_document$getElements, 1),
        head = _document$getElements2[0];

    head.appendChild(htmlDiv);
  });
  return /*#__PURE__*/_react["default"].createElement(LegoContext.Provider, {
    value: context
  }, children);
};

exports.LegoProvider = LegoProvider;

var useTheme = function useTheme() {
  var context = (0, _react.useContext)(LegoContext);
  return context.theming.theme;
};

exports.useTheme = useTheme;

var useTheming = function useTheming() {
  var context = (0, _react.useContext)(LegoContext);
  return context.theming;
};

exports.useTheming = useTheming;

var LegoNavigator = /*#__PURE__*/function () {
  function LegoNavigator(context) {
    (0, _classCallCheck2["default"])(this, LegoNavigator);
    this.context = void 0;
    this.context = context || defaultContext;
  }

  (0, _createClass2["default"])(LegoNavigator, [{
    key: "navigate",
    value: function () {
      var _navigate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, options) {
        var navigationContext, openInNewTab;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                navigationContext = this.context.navigation;

                if (!(navigationContext != null)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return navigationContext.navigate(url, options);

              case 4:
                return _context.abrupt("return");

              case 5:
                openInNewTab = (options === null || options === void 0 ? void 0 : options.openInNewTab) == true;

                if (!openInNewTab) {
                  _context.next = 9;
                  break;
                }

                window.open(url, "_blank");
                return _context.abrupt("return");

              case 9:
                // Only manual navigation is available here since navigation
                // context was not provided to lego.
                // eslint-disable-next-line local-rules/no-manual-navigation
                window.location.href = url;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function navigate(_x, _x2) {
        return _navigate.apply(this, arguments);
      }

      return navigate;
    }()
  }, {
    key: "pushPath",
    value: function pushPath(path, queryParams) {
      var navigationContext = this.context.navigation;

      if (navigationContext == null) {
        throw "Please provide navigation options to lego";
      }

      navigationContext.pushPath(path, queryParams);
    }
  }, {
    key: "getQueryParameters",
    value: function getQueryParameters() {
      var navigationContext = this.context.navigation;

      if (navigationContext == null) {
        throw "Please provide navigation options to lego";
      }

      return navigationContext.getQueryParameters();
    }
  }, {
    key: "getCurrentPath",
    value: function getCurrentPath() {
      var navigationContext = this.context.navigation;

      if (navigationContext == null) {
        throw "Please provide navigation options to lego";
      }

      return navigationContext.getCurrentPath();
    }
  }]);
  return LegoNavigator;
}();

exports.LegoNavigator = LegoNavigator;

var LegoToaster = /*#__PURE__*/function () {
  function LegoToaster(context) {
    (0, _classCallCheck2["default"])(this, LegoToaster);
    this.context = void 0;
    this.context = context || defaultContext;
  }

  (0, _createClass2["default"])(LegoToaster, [{
    key: "warning",
    value: function warning(message) {
      var toastContext = this.context.toasts;

      if (toastContext == null) {
        window.alert(message);
        return;
      }

      toastContext.warning(message);
    }
  }, {
    key: "negative",
    value: function negative(message) {
      var toastContext = this.context.toasts;

      if (toastContext == null) {
        window.alert(message);
        return;
      }

      toastContext.negative(message);
    }
  }, {
    key: "positive",
    value: function positive(message) {
      var toastContext = this.context.toasts;

      if (toastContext == null) {
        window.alert(message);
        return;
      }

      toastContext.positive(message);
    }
  }]);
  return LegoToaster;
}();

exports.LegoToaster = LegoToaster;

var useLegoNavigator = function useLegoNavigator() {
  var context = (0, _react.useContext)(LegoContext);
  return (0, _react.useMemo)(function () {
    return new LegoNavigator(context);
  }, [context]);
};

exports.useLegoNavigator = useLegoNavigator;